import React from "react";
import CustomModal from "../../../Core/Components/Modal/CustomModal";
import { CloseWithCircleIcon } from "../../../Common/Svgs/CloseIcon";
import Button from "../../../Core/Components/CustomButton";
import { TickWithBgIcon } from "../../../Common/Svgs/TickIcon";

const SuccessModal = ({ visible, onCancel }) => {
  const onSuccess = () => {
    const deeplink = "myapp://sessions/before-end-session";
    window.location.href = deeplink;
  };

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="536px">
      <div
        className="p-4"
        style={{
          boxShadow:
            "12px 12px 16px -4px rgba(16, 24, 40, 0.08), -4px -4px 6px -2px rgba(16, 24, 40, 0.03)",
        }}
      >
        <div className="flex items-center justify-between">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EDF8F2]">
            <TickWithBgIcon size={32} className="text-[#4DCA86]" />
          </div>

          <button type="button" className="mr-2" onClick={onCancel}>
            <CloseWithCircleIcon />
          </button>
        </div>

        <div className="mt-5 px-2 pb-2">
          <h1 className="font-poppins text-xl font-semibold">Success!</h1>

          <p className="mt-1 font-aileron text-sm font-normal text-grey-200">
            All points of the land were marked successfully.
          </p>

          <div className="mt-6">
            <Button
              colors="primary"
              size="primary"
              width="full"
              onClick={onSuccess}
            >
              Proceed To Session
            </Button>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default SuccessModal;
